import { createContext } from 'react';

export const LayoutPayCompanyContext = createContext({
  toggle: false,
  onToggle: () => null,
});
